import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SICOM_PATHS } from 'src/sicom-paths';
import { PrestadorRecursoHumano, PrestadorRecursoHumanoRequest } from './prestador-recursos-humanos.model';

@Injectable({ providedIn: 'root' })
export class PrestadorRecursosHumanosService {
    private readonly http = inject(HttpClient);
    private readonly url = SICOM_PATHS.registro.prestador.recursosHumanos;
    listar(id: number, uf: string) {
        return this.http.get<PrestadorRecursoHumano[]>(this.url, { params: { id, uf } });
    }
    tipos() {
        return this.http.get<PrestadorRecursoHumano[]>(`${this.url}/tipos`);
    }
    criar(request: PrestadorRecursoHumanoRequest) {
        return this.http.post<void>(this.url, request);
    }
    atualizar(request: PrestadorRecursoHumanoRequest) {
        return this.http.put<void>(this.url, request);
    }
    remover(request: PrestadorRecursoHumanoRequest) {
        return this.http.delete<void>(this.url, { body: request });
    }
}
